let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      // Isolate subscribers: a throw in one must not prevent the others from
      // running (e.g. a product-page subscriber throwing must not stop the cart
      // drawer from refreshing on cart-update).
      try {
        callback(data);
      } catch (e) {
        console.error(`pub/sub subscriber for "${eventName}" threw:`, e);
      }
    });
  }
}
